import React from 'react';

const InfoBlue: ReactFCWithChildren<JSX.IntrinsicElements['svg']> = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect id="Rectangle" x="0" y="0" width="20" height="20"></rect>
      <path
        d="M9.99,0 C15.52,0 20,4.48 20,10 C20,15.52 15.52,20 9.99,20 C4.47,20 0,15.52 0,10 C0,4.48 4.47,0 9.99,0 Z M10,2 C5.58,2 2,5.58 2,10 C2,14.42 5.58,18 10,18 C14.42,18 18,14.42 18,10 C18,5.58 14.42,2 10,2 Z M10.2222222,13.2777778 C10.774507,13.2777778 11.2222222,13.725493 11.2222222,14.2777778 L11.2222222,14.5 C11.2222222,15.0522847 10.774507,15.5 10.2222222,15.5 L10,15.5 C9.44771525,15.5 9,15.0522847 9,14.5 L9,14.2777778 C9,13.725493 9.44771525,13.2777778 10,13.2777778 L10.2222222,13.2777778 Z M10.2222222,4.5 C10.774507,4.5 11.2222222,4.94771525 11.2222222,5.5 L11.2222222,11.2777778 C11.2222222,11.8300625 10.774507,12.2777778 10.2222222,12.2777778 L10,12.2777778 C9.44771525,12.2777778 9,11.8300625 9,11.2777778 L9,5.5 C9,4.94771525 9.44771525,4.5 10,4.5 L10.2222222,4.5 Z"
        fill="#56A2FF"
      ></path>
    </svg>
  );
};

export default InfoBlue;
